import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'boolean',
  standalone: false,
})
export class BooleanPipe implements PipeTransform {
  transform(value: boolean): string {
    return value ? $localize`Si` : $localize`No`;
  }
}
